import { Builder, BuilderAsyncRequestsContext, BuilderStoreContext, BuilderBlocks, stringToFunction, BuilderBlockComponent } from '@builder.io/react';
import { __extends, __assign } from 'tslib';
import * as React from 'react';
import Slider from 'react-slick';
import Masonry from 'react-masonry-component';

// TODO: change to slick grid
var CarouselComponent = /** @class */function (_super) {
  __extends(CarouselComponent, _super);
  function CarouselComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.divRef = /*#__PURE__*/React.createRef();
    _this.sliderRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  CarouselComponent.prototype.componentDidMount = function () {
    var _this = this;
    setTimeout(function () {
      var _a;
      (_a = _this.divRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent('builder:carousel:load', {
        bubbles: true,
        cancelable: false,
        detail: {
          block: _this.props.builderBlock,
          carousel: _this.sliderRef.current
        }
      }));
    });
  };
  CarouselComponent.prototype.render = function () {
    var _this = this;
    var slides = this.props.slides;
    if (slides && !Builder.isBrowser) {
      slides = slides.slice(0, 1);
    }
    return /*#__PURE__*/React.createElement(BuilderAsyncRequestsContext.Consumer, null, function (value) {
      _this._errors = value && value.errors;
      _this._logs = value && value.logs;
      return /*#__PURE__*/React.createElement(BuilderStoreContext.Consumer, null, function (state) {
        return /*#__PURE__*/React.createElement("div", {
          ref: _this.divRef,
          className: "builder-carousel"
        }, Builder.isServer ? (/*#__PURE__*/React.createElement("style", {
          type: "text/css",
          dangerouslySetInnerHTML: {
            __html: slickStyles
          }
        })) : (/*#__PURE__*/React.createElement("style", {
          type: "text/css"
        }, slickStyles)), /*#__PURE__*/React.createElement(Slider, __assign({
          responsive: _this.props.responsive,
          ref: _this.sliderRef,
          afterChange: function afterChange(slide) {
            var _a;
            // TODO; callbacks
            if (_this.divRef) {
              (_a = _this.divRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent('builder:carousel:change', {
                bubbles: true,
                cancelable: false,
                detail: {
                  slide: slide,
                  block: _this.props.builderBlock,
                  carousel: _this.sliderRef.current
                }
              }));
            }
          },
          autoplay: _this.props.autoplay,
          autoplaySpeed: _this.props.autoplaySpeed ? _this.props.autoplaySpeed * 1000 : undefined,
          dots: !_this.props.hideDots,
          // TODO: on change emit event on element?
          // renderBottomCenterControls={this.props.hideDots ? () => null : undefined}
          // OOF!!
          nextArrow: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BuilderBlocks, {
            parentElementId: _this.props.builderBlock.id,
            dataPath: "component.options.prevButton",
            blocks: _this.props.prevButton
          })),
          // OOF!!
          prevArrow: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BuilderBlocks, {
            parentElementId: _this.props.builderBlock.id,
            dataPath: "component.options.nextButton",
            blocks: _this.props.nextButton
          }))
        }, _this.props.slickProps), _this.props.useChildrenForSlides ? _this.props.builderBlock && _this.props.builderBlock.children && _this.props.builderBlock.children.map(function (block, index) {
          if (block.repeat && block.repeat.collection) {
            var collectionPath = block.repeat.collection;
            var collectionName = (collectionPath || '').split(/\.\w+\(/)[0].trim().split('.').pop();
            var itemName_1 = block.repeat.itemName || (collectionName ? collectionName + 'Item' : 'item');
            var array = stringToFunction(collectionPath, true, _this._errors, _this._logs)(state.state);
            if (Array.isArray(array)) {
              if (!Builder.isBrowser) {
                array = array.slice(0, 1);
              }
              return array.map(function (data, index) {
                var _a;
                // TODO: Builder state produce the data
                var childState = __assign(__assign({}, state.state), (_a = {}, _a[itemName_1] = data, _a.$index = index, _a.$item = data, _a));
                return /*#__PURE__*/React.createElement(BuilderStoreContext.Provider, {
                  key: block.id,
                  value: __assign(__assign({}, state), {
                    state: childState
                  })
                }, /*#__PURE__*/React.createElement(BuilderBlockComponent, {
                  block: __assign(__assign({}, block), {
                    repeat: null
                  }),
                  index: index,
                  child /* TODO: fieldname? */: true
                }));
              });
            }
          }
          return /*#__PURE__*/React.createElement(BuilderBlockComponent, {
            key: block.id,
            block: block,
            index: index,
            child /* TODO: fieldname? */: true
          });
        }) : _this.props.slides && _this.props.slides.map(function (slide, index) {
          return (
            /*#__PURE__*/
            // TODO: how make react compatible with plain react components
            // slides: <Foo><Bar> <- builder blocks if passed react nodes as blocks just forward them
            React.createElement(React.Fragment, {
              key: index
            }, /*#__PURE__*/React.createElement(BuilderBlocks, {
              parentElementId: _this.props.builderBlock && _this.props.builderBlock.id,
              dataPath: "component.options.slides.".concat(index, ".content"),
              child: true,
              blocks: slide.content || slide
            }))
          );
        })));
      });
    });
  };
  return CarouselComponent;
}(React.Component);
var slickStyles = "@charset 'UTF-8';\n\n.builder-carousel .slick-list,\n.builder-carousel .slick-slider,\n.builder-carousel .slick-track {\n  position: relative;\n  display: block\n}\n\n.builder-carousel .slick-loading .slick-slide,\n.builder-carousel .slick-loading .slick-track {\n  visibility: hidden\n}\n\n.builder-carousel .slick-slider {\n  box-sizing: border-box;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -khtml-user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent\n}\n\n.builder-carousel .slick-list {\n  overflow: hidden;\n  margin: 0;\n  padding: 0\n}\n\n.builder-carousel .slick-list:focus {\n  outline: 0\n}\n\n.builder-carousel .slick-list.dragging {\n  cursor: pointer;\n  cursor: hand\n}\n\n.builder-carousel .slick-slider .slick-list,\n.builder-carousel .slick-slider .slick-track {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0)\n}\n\n.builder-carousel .slick-track {\n  top: 0;\n  left: 0\n}\n\n.builder-carousel .slick-track:after,\n.builder-carousel .slick-track:before {\n  display: table;\n  content: ''\n}\n\n.builder-carousel .slick-track:after {\n  clear: both\n}\n\n.builder-carousel .slick-slide {\n  display: none;\n  float: left;\n  height: auto;\n  min-height: 1px\n}\n\n.builder-carousel [dir=rtl] .slick-slide {\n  float: right\n}\n\n.builder-carousel .slick-slide img {\n  display: block\n}\n\n.builder-carousel .slick-slide.slick-loading img {\n  display: none\n}\n\n.builder-carousel .slick-slide.dragging img {\n  pointer-events: none\n}\n\n.builder-carousel .slick-initialized .slick-slide {\n  display: block\n}\n\n.builder-carousel .slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent\n}\n\n.builder-carousel .slick-arrow.slick-hidden {\n  display: none\n}\n\n.builder-carousel .slick-dots,\n.builder-carousel .slick-next,\n.builder-carousel .slick-prev {\n  position: absolute;\n  display: block;\n  padding: 0\n}\n\n.builder-carousel .slick-dots li button:before,\n.builder-carousel .slick-next:before,\n.builder-carousel .slick-prev:before {\n  font-family: slick;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale\n}\n\n.builder-carousel .slick-loading .slick-list {\n  background: url(ajax-loader.gif) center center no-repeat #fff\n}\n\n@font-face {\n  font-display: swap;\n  font-family: slick;\n  font-weight: 400;\n  font-style: normal;\n  src: url(https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/fonts/slick.eot);\n  src: local(\"slick\"), url(https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/fonts/slick.eot?#iefix) format('embedded-opentype'), url(https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/fonts/slick.woff) format('woff'), url(https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/fonts/slick.ttf) format('truetype'), url(https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/fonts/slick.svg#slick) format('svg')\n}\n\n.builder-carousel .slick-next,\n.builder-carousel .slick-prev {\n  font-size: 0;\n  line-height: 0;\n  top: 50%;\n  width: 20px;\n  height: 20px;\n  -webkit-transform: translate(0, -50%);\n  -ms-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  cursor: pointer;\n  color: transparent;\n  border: none;\n  outline: 0;\n  background: 0 0\n}\n\n.builder-carousel .slick-next:focus,\n.builder-carousel .slick-next:hover,\n.builder-carousel .slick-prev:focus,\n.builder-carousel .slick-prev:hover {\n  color: transparent;\n  outline: 0;\n  background: 0 0\n}\n\n.builder-carousel .slick-next:focus:before,\n.builder-carousel .slick-next:hover:before,\n.builder-carousel .slick-prev:focus:before,\n.builder-carousel .slick-prev:hover:before {\n  opacity: 1\n}\n\n.builder-carousel .slick-next.slick-disabled:before,\n.builder-carousel .slick-prev.slick-disabled:before {\n  opacity: .25\n}\n\n.builder-carousel .slick-next:before,\n.builder-carousel .slick-prev:before {\n  font-size: 20px;\n  line-height: 1;\n  opacity: .75;\n  color: #fff\n}\n\n.builder-carousel .slick-prev {\n  left: -25px\n}\n\n.builder-carousel [dir=rtl] .slick-prev {\n  right: -25px;\n  left: auto\n}\n\n.builder-carousel .slick-prev:before {\n  content: ''\n}\n\n.builder-carousel .slick-next:before,\n.builder-carousel [dir=rtl] .slick-prev:before {\n  content: ''\n}\n\n.builder-carousel .slick-next {\n  right: -25px\n}\n\n.builder-carousel [dir=rtl] .slick-next {\n  right: auto;\n  left: -25px\n}\n\n.builder-carousel [dir=rtl] .slick-next:before {\n  content: '\u2022\x90'\n}\n\n.builder-carousel .slick-dotted.slick-slider {\n  margin-bottom: 30px\n}\n\n.builder-carousel .slick-dots {\n  bottom: -25px;\n  width: 100%;\n  margin: 0;\n  list-style: none;\n  text-align: center\n}\n\n.builder-carousel .slick-dots li {\n  position: relative;\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin: 0 5px;\n  padding: 0;\n  cursor: pointer\n}\n\n.builder-carousel .slick-dots li button {\n  font-size: 0;\n  line-height: 0;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 5px;\n  cursor: pointer;\n  color: transparent;\n  border: 0;\n  outline: 0;\n  background: 0 0\n}\n\n.builder-carousel .slick-dots li button:focus,\n.builder-carousel .slick-dots li button:hover {\n  outline: 0\n}\n\n.builder-carousel .slick-dots li button:focus:before,\n.builder-carousel .slick-dots li button:hover:before {\n  opacity: 1\n}\n\n.builder-carousel .slick-dots li button:before {\n  font-size: 6px;\n  line-height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  content: '\u2022';\n  text-align: center;\n  opacity: .25;\n  color: #000\n}\n\n.builder-carousel .slick-dots li.slick-active button:before {\n  opacity: .75;\n  color: #000\n}\n\n.builder-carousel img {\n  pointer-events: none\n}\n";
var TabsComponent = /** @class */function (_super) {
  __extends(TabsComponent, _super);
  function TabsComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      activeTab: 0
    };
    return _this;
  }
  Object.defineProperty(TabsComponent.prototype, "activeTabSpec", {
    get: function get() {
      return this.props.tabs && this.props.tabs[this.state.activeTab];
    },
    enumerable: false,
    configurable: true
  });
  TabsComponent.prototype.componentWillMount = function () {
    if (this.props.defaultActiveTab) {
      this.activeTab = this.props.defaultActiveTab - 1;
    }
  };
  Object.defineProperty(TabsComponent.prototype, "activeTab", {
    get: function get() {
      return this.state.activeTab;
    },
    set: function set(tab) {
      this.setState(__assign(__assign({}, this.state), {
        activeTab: tab
      }));
    },
    enumerable: false,
    configurable: true
  });
  TabsComponent.prototype.render = function () {
    var _this = this;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: this.props.tabHeaderLayout,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch'
      },
      className: "builder-tabs-wrap"
    }, this.props.tabs && this.props.tabs.map(function (item, index) {
      return /*#__PURE__*/React.createElement("span", {
        key: index,
        className: 'builder-tab-wrap ' + (_this.activeTabSpec === item ? 'builder-tab-active' : ''),
        style: __assign({}, _this.activeTabSpec === item && _this.props.activeTabStyle || undefined),
        onClick: function onClick() {
          if (index === _this.activeTab && _this.props.collapsible) {
            _this.activeTab = -1;
          } else {
            _this.activeTab = index;
          }
        }
      }, /*#__PURE__*/React.createElement(BuilderBlocks
      // TODO: parent={this.props.builderBlock}
      , {
        // TODO: parent={this.props.builderBlock}
        parentElementId: _this.props.builderBlock.id,
        // TODO: start with just "tabs." when bump react version
        dataPath: "component.options.tabs.".concat(_this.state.activeTab, ".label"),
        blocks: item.label
      }));
    })), this.activeTabSpec && (/*#__PURE__*/React.createElement(BuilderBlocks, {
      parentElementId: this.props.builderBlock.id,
      dataPath: "component.options.tabs.".concat(this.state.activeTab, ".content"),
      blocks: this.activeTabSpec.content
    })));
  };
  return TabsComponent;
}(React.Component);

// TODO: change to slick grid
var AccordionComponent = /** @class */function (_super) {
  __extends(AccordionComponent, _super);
  function AccordionComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.divRef = null;
    _this.state = {
      open: []
    };
    return _this;
  }
  AccordionComponent.prototype.componentDidMount = function () {
    var _this = this;
    setTimeout(function () {
      if (_this.divRef) {
        _this.divRef.dispatchEvent(new CustomEvent('builder:accordion:load', {
          bubbles: true,
          cancelable: false,
          detail: {
            ref: _this
          }
        }));
      }
    });
  };
  AccordionComponent.prototype.getAccordionItem = function (titleBlocks, detailBlocks, index, openGridItemOrder, onlyOneAtATime, fromChildren) {
    var _this = this;
    if (fromChildren === void 0) {
      fromChildren = false;
    }
    var open = this.state.open.indexOf(index) !== -1;
    var grid = this.props.grid;
    return (
      /*#__PURE__*/
      // This will not work as expected with react 15
      // Did preact get the span replacmenet too?
      React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "builder-accordion-title builder-accordion-title-".concat(open ? 'open' : 'closed'),
        style: __assign({
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch'
        }, grid && __assign({
          width: this.props.gridRowWidth
        }, typeof openGridItemOrder === 'number' && {
          order: index < openGridItemOrder ? index : index + 1
        })),
        "data-index": index,
        onClick: function onClick() {
          if (open) {
            _this.setState(__assign(__assign({}, _this.state), {
              open: onlyOneAtATime ? [] : _this.state.open.filter(function (item) {
                return item !== index;
              })
            }));
          } else {
            _this.setState(__assign(__assign({}, _this.state), {
              open: onlyOneAtATime ? [index] : _this.state.open.concat(index)
            }));
          }
        }
      }, fromChildren ? titleBlocks.map(function (block, index) {
        return /*#__PURE__*/React.createElement(BuilderBlockComponent, {
          key: index,
          block: __assign(__assign({}, block), {
            repeat: null
          }),
          index: index,
          child: true
        });
      }) : (/*#__PURE__*/React.createElement(BuilderBlocks, {
        blocks: titleBlocks,
        dataPath: "items.".concat(index, ".title")
      }))), open && (/*#__PURE__*/React.createElement("div", {
        className: "builder-accordion-detail builder-accordion-detail-".concat(open ? 'open' : 'closed'),
        style: __assign({
          order: typeof openGridItemOrder === 'number' ? openGridItemOrder : undefined
        }, grid && {
          width: '100%'
        })
      }, open && (fromChildren ? detailBlocks.map(function (block, index) {
        return /*#__PURE__*/React.createElement(BuilderBlockComponent, {
          key: index,
          block: __assign(__assign({}, block), {
            repeat: null
          }),
          index: index,
          child: true
        });
      }) : (/*#__PURE__*/React.createElement(BuilderBlocks, {
        blocks: detailBlocks,
        dataPath: "items.".concat(index, ".detail")
      }))))))
    );
  };
  AccordionComponent.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      grid = _a.grid,
      oneAtATime = _a.oneAtATime;
    var onlyOneAtATime = Boolean(grid || oneAtATime);
    var getOpenGridItemPosition = grid && this.state.open.length;
    var openGridItemOrder = null;
    if (getOpenGridItemPosition && this.divRef) {
      var openItemIndex = this.state.open[0];
      var openItem = this.divRef.querySelector(".builder-accordion-title[data-index=\"".concat(openItemIndex, "\"]"));
      var subjectItem = openItem;
      openGridItemOrder = openItemIndex;
      if (subjectItem) {
        var prevItemRect = subjectItem.getBoundingClientRect();
        while (subjectItem = subjectItem && subjectItem.nextElementSibling) {
          if (subjectItem) {
            if (subjectItem.classList.contains('builder-accordion-detail')) {
              continue;
            }
            var subjectItemRect = subjectItem.getBoundingClientRect();
            if (subjectItemRect.left > prevItemRect.left) {
              var index = parseInt(subjectItem.getAttribute('data-index') || '', 10);
              if (!isNaN(index)) {
                prevItemRect = subjectItemRect;
                openGridItemOrder = index;
              }
            } else {
              break;
            }
          }
        }
      }
    }
    if (typeof openGridItemOrder === 'number') {
      openGridItemOrder = openGridItemOrder + 1;
    }
    return /*#__PURE__*/React.createElement(BuilderAsyncRequestsContext.Consumer, null, function (value) {
      _this._errors = value && value.errors;
      _this._logs = value && value.logs;
      return /*#__PURE__*/React.createElement(BuilderStoreContext.Consumer, null, function (state) {
        return /*#__PURE__*/React.createElement("div", {
          ref: function ref(_ref) {
            return _this.divRef = _ref;
          },
          className: "builder-accordion",
          style: __assign({
            display: 'flex',
            alignItems: 'stretch',
            flexDirection: 'column'
          }, grid && {
            flexDirection: 'row',
            alignItems: 'flex-start',
            flexWrap: 'wrap'
          })
        }, _this.props.useChildrenForItems ? _this.props.builderBlock && _this.props.builderBlock.children && _this.props.builderBlock.children.map(function (block, index) {
          if (block.repeat && block.repeat.collection) {
            var collectionPath = block.repeat.collection;
            var collectionName = (collectionPath || '').split(/\.\w+\(/)[0].trim().split('.').pop();
            var itemName_1 = block.repeat.itemName || (collectionName ? collectionName + 'Item' : 'item');
            var array = stringToFunction(collectionPath, true, _this._errors, _this._logs)(state.state);
            if (Array.isArray(array)) {
              return array.map(function (data, index) {
                var _a;
                // TODO: Builder state produce the data
                var childState = __assign(__assign({}, state.state), (_a = {
                  $index: index,
                  $item: data
                }, _a[itemName_1] = data, _a));
                return /*#__PURE__*/React.createElement(BuilderStoreContext.Provider, {
                  key: block.id,
                  value: __assign(__assign({}, state), {
                    state: childState
                  })
                }, _this.getAccordionItem(block.children ? [block.children[0]] : [], block.children ? [block.children[1]] : [], index, openGridItemOrder, onlyOneAtATime, true));
              });
            }
          }
          return _this.getAccordionItem(block.children ? [block.children[0]] : [], block.children ? [block.children[1]] : [], index, openGridItemOrder, onlyOneAtATime, true);
        }) : _this.props.items && _this.props.items.map(function (item, index) {
          return _this.getAccordionItem(item.title, item.detail, index, openGridItemOrder, onlyOneAtATime);
        }));
      });
    });
  };
  return AccordionComponent;
}(React.Component);

// TODO: column with, gutter, etc options
var MasonryComponent = /** @class */function (_super) {
  __extends(MasonryComponent, _super);
  function MasonryComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.divRef = null;
    _this.masonryRef = null;
    _this.state = {
      layoutComplete: false
    };
    return _this;
  }
  MasonryComponent.prototype.componentDidMount = function () {
    var _this = this;
    setTimeout(function () {
      if (_this.divRef) {
        _this.divRef.dispatchEvent(new CustomEvent('builder:masonry:load', {
          bubbles: true,
          cancelable: false,
          detail: {
            block: _this.props.builderBlock,
            ref: _this.divRef,
            masonry: _this.masonryRef
          }
        }));
      }
      if (Builder.isEditing) ;
    });
  };
  MasonryComponent.prototype.render = function () {
    var _this = this;
    this.props.tiles;
    // if (slides && !Builder.isBrowser) {
    //   slides = slides.slice(0, 1)
    // }
    var itemStyle = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      width: this.props.columnWidth
    };
    return /*#__PURE__*/React.createElement("div", {
      style: {
        opacity: Builder.isBrowser && this.state.layoutComplete ? 1 : 0,
        transition: 'opacity 0.2s'
      }
    }, /*#__PURE__*/React.createElement(BuilderAsyncRequestsContext.Consumer, null, function (value) {
      _this._errors = value && value.errors;
      _this._logs = value && value.logs;
      return /*#__PURE__*/React.createElement(BuilderStoreContext.Consumer, null, function (state) {
        return /*#__PURE__*/React.createElement("div", {
          ref: function ref(_ref2) {
            return _this.divRef = _ref2;
          },
          className: "builder-masonry"
        }, /*#__PURE__*/React.createElement(Masonry, {
          onLayoutComplete: function onLayoutComplete() {
            if (!_this.state.layoutComplete) {
              _this.setState(__assign(__assign({}, _this.state), {
                layoutComplete: true
              }));
            }
          },
          options: {
            gutter: _this.props.gutterSize,
            // Maybe us this
            fitWidth: _this.props.columnWidth && _this.props.columnWidth.endsWith('%') ? false : true,
            percentPosition:
            // TODO: option to override this too
            _this.props.columnWidth && (_this.props.columnWidth.endsWith('%') || _this.props.columnWidth.startsWith('.')) || false
          },
          ref: function ref(_ref3) {
            return _this.masonryRef = _ref3;
          }
        }, _this.props.useChildrenForTiles ? _this.props.builderBlock && _this.props.builderBlock.children && _this.props.builderBlock.children.map(function (block, index) {
          if (block.repeat && block.repeat.collection) {
            var collectionPath = block.repeat.collection;
            var collectionName = (collectionPath || '').split(/\.\w+\(/)[0].trim().split('.').pop();
            var itemName_1 = block.repeat.itemName || (collectionName ? collectionName + 'Item' : 'item');
            var array = stringToFunction(collectionPath, true, _this._errors, _this._logs)(state.state);
            if (Array.isArray(array)) {
              if (!Builder.isBrowser) {
                array = array.slice(0, 1);
              }
              return array.map(function (data, index) {
                var _a;
                // TODO: Builder state produce the data
                var childState = __assign(__assign({}, state.state), (_a = {
                  $index: index,
                  $item: data
                }, _a[itemName_1] = data, _a));
                return /*#__PURE__*/React.createElement("div", {
                  className: "masonry-item",
                  style: itemStyle
                }, /*#__PURE__*/React.createElement(BuilderStoreContext.Provider, {
                  key: block.id,
                  value: __assign(__assign({}, state), {
                    state: childState
                  })
                }, /*#__PURE__*/React.createElement(BuilderBlockComponent, {
                  block: __assign(__assign({}, block), {
                    repeat: null
                  }),
                  index: index,
                  child: true
                })));
              });
            }
          }
          return /*#__PURE__*/React.createElement("div", {
            style: itemStyle,
            className: "masonry-item"
          }, /*#__PURE__*/React.createElement(BuilderBlockComponent, {
            key: block.id,
            block: block,
            index: index,
            child: true
          }));
        }) : _this.props.tiles && _this.props.tiles.map(function (tile, index) {
          return (
            /*#__PURE__*/
            // TODO: how make react compatible with plain react components
            // tiles: <Foo><Bar> <- builder blocks if passed react nodes as blocks just forward them
            React.createElement("div", {
              style: itemStyle,
              className: "masonry-item"
            }, /*#__PURE__*/React.createElement(BuilderBlocks, {
              key: index,
              parentElementId: _this.props.builderBlock && _this.props.builderBlock.id,
              dataPath: "component.options.tiles.".concat(index, ".content"),
              child: true,
              blocks: tile.content || tile
            }))
          );
        })));
      });
    }));
  };
  return MasonryComponent;
}(React.Component);
var defaultElement$1 = {
  '@type': '@builder.io/sdk:Element',
  responsiveStyles: {
    large: {
      // TODO: always apply these if not given
      position: 'relative',
      display: 'flex',
      alignItems: 'stretch',
      flexDirection: 'column',
      height: '400px'
    }
  },
  children: [{
    '@type': '@builder.io/sdk:Element',
    responsiveStyles: {
      large: {
        marginTop: '50px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column'
      }
    },
    component: {
      name: 'Text',
      options: {
        text: 'I am a slide'
      }
    }
  }]
};
var defaultButton = {
  '@type': '@builder.io/sdk:Element',
  responsiveStyles: {
    large: {
      position: 'relative',
      display: 'flex',
      alignItems: 'stretch',
      flexDirection: 'column',
      height: '30px'
    }
  }
};
var carouselConfig = {
  name: 'Builder:Carousel',
  // TODO: default children
  canHaveChildren: true,
  defaultStyles: {
    paddingLeft: '30px',
    paddingRight: '30px',
    paddingBottom: '30px'
  },
  inputs: [{
    name: 'slides',
    type: 'list',
    broadcast: true,
    subFields: [{
      name: 'content',
      type: 'uiBlocks',
      hideFromUI: true,
      defaultValue: [defaultElement$1]
    }],
    defaultValue: [{
      content: [defaultElement$1]
    }, {
      content: [defaultElement$1]
    }],
    showIf: function showIf(options) {
      return !options.get('useChildrenForSlides');
    }
  }, {
    name: 'hideDots',
    helperText: 'Hide pagination dots',
    type: 'boolean',
    defaultValue: false
  }, {
    name: 'autoplay',
    helperText: 'Automatically rotate to the next slide every few seconds',
    type: 'boolean',
    defaultValue: false
  }, {
    name: 'autoplaySpeed',
    type: 'number',
    defaultValue: 5,
    helperText: 'If auto play is on, how many seconds to wait before automatically changing each slide',
    showIf: function showIf(options) {
      return options.get('autoplay');
    }
  }, {
    name: 'prevButton',
    type: 'uiBlocks',
    hideFromUI: true,
    defaultValue: [__assign(__assign({}, defaultButton), {
      component: {
        name: 'Image',
        options: {
          image: 'https://cdn.builder.io/api/v1/image/assets%2FagZ9n5CUKRfbL9t6CaJOyVSK4Es2%2Fd909a5b91650499c9e0524cc904eeb77'
        }
      }
    })]
  }, {
    name: 'nextButton',
    type: 'uiBlocks',
    hideFromUI: true,
    defaultValue: [__assign(__assign({}, defaultButton), {
      component: {
        name: 'Image',
        options: {
          image: 'https://cdn.builder.io/api/v1/image/assets%2FagZ9n5CUKRfbL9t6CaJOyVSK4Es2%2Fdb2a9827561249aea3817b539aacdcdc'
        }
      }
    })]
  }, {
    name: 'useChildrenForSlides',
    type: 'boolean',
    helperText: 'Use child elements for each slide, instead of the array. Useful for dynamically repeating slides',
    advanced: true,
    defaultValue: false,
    onChange: function onChange(options) {
      if (options.get('useChildrenForSlides') === true) {
        options.set('slides', []);
      }
    }
  }, {
    name: 'responsive',
    type: 'array',
    helperText: 'Responsive settings - e.g. see https://kenwheeler.github.io/slick/',
    advanced: true,
    defaultValue: [{
      width: 3000,
      slidesToShow: 2,
      slidesToScroll: 2
    }, {
      width: 400,
      slidesToShow: 1,
      slidesToScroll: 1
    }],
    subFields: [{
      name: 'breakpoint',
      type: 'number',
      defaultValue: 400,
      required: true
    }, {
      name: 'settings',
      type: 'object',
      defaultValue: {
        slidesToShow: 2,
        slidesToScroll: 2
      },
      subFields: [{
        name: 'slidesToShow',
        type: 'number',
        defaultValue: 2
      }, {
        name: 'slidesToScroll',
        type: 'number',
        defaultValue: 2
      }, {
        name: 'infinite',
        type: 'boolean',
        defaultValue: true
      }, {
        name: 'dots',
        type: 'boolean',
        defaultValue: true
      }]
    }]
  }]
};
var defaultTab = {
  '@type': '@builder.io/sdk:Element',
  responsiveStyles: {
    large: {
      paddingLeft: '20px',
      paddingRight: '20px',
      paddingTop: '10px',
      paddingBottom: '10px',
      minWidth: '100px',
      textAlign: 'center',
      // TODO: add to all
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
      userSelect: 'none'
    }
  },
  component: {
    // Builder:text
    name: 'Text',
    options: {
      text: 'New tab'
    }
  }
};
var defaultElement = {
  '@type': '@builder.io/sdk:Element',
  responsiveStyles: {
    large: {
      height: '200px',
      display: 'flex',
      marginTop: '20px',
      flexDirection: 'column'
    }
  },
  component: {
    name: 'Text',
    options: {
      text: 'New tab content '
    }
  }
};
var tabsConfig = {
  name: 'Builder: Tabs',
  inputs: [{
    name: 'tabs',
    type: 'list',
    broadcast: true,
    subFields: [{
      name: 'label',
      type: 'uiBlocks',
      hideFromUI: true,
      defaultValue: [defaultTab]
    }, {
      name: 'content',
      type: 'uiBlocks',
      hideFromUI: true,
      defaultValue: [defaultElement]
    }],
    defaultValue: [{
      label: [__assign(__assign({}, defaultTab), {
        component: {
          name: 'Text',
          options: {
            text: 'Tab 1'
          }
        }
      })],
      content: [__assign(__assign({}, defaultElement), {
        component: {
          name: 'Text',
          options: {
            text: 'Tab 1 content'
          }
        }
      })]
    }, {
      label: [__assign(__assign({}, defaultTab), {
        component: {
          name: 'Text',
          options: {
            text: 'Tab 2'
          }
        }
      })],
      content: [__assign(__assign({}, defaultElement), {
        component: {
          name: 'Text',
          options: {
            text: 'Tab 2 content'
          }
        }
      })]
    }]
  }, {
    name: 'activeTabStyle',
    type: 'uiStyle',
    helperText: 'CSS styles for the active tab',
    defaultValue: {
      backgroundColor: 'rgba(0, 0, 0, 0.1)'
    }
  }, {
    name: 'defaultActiveTab',
    type: 'number',
    helperText: 'Deafult tab to open to. Set to "1" for the first tab, "2" for the second, or choose "0" for none',
    defaultValue: 1,
    advanced: true
  }, {
    name: 'collapsible',
    type: 'boolean',
    helperText: 'If on, clicking an open tab closes it so no tabs are active',
    defaultValue: false,
    advanced: true
  }, {
    name: 'tabHeaderLayout',
    type: 'enum',
    helperText: 'Change the layout of the tab headers (uses justify-content)',
    defaultValue: 'flex-start',
    enum: [{
      label: 'Center',
      value: 'center'
    }, {
      label: 'Space between',
      value: 'space-between'
    }, {
      label: 'Space around',
      value: 'space-around'
    }, {
      label: 'Left',
      value: 'flex-start'
    }, {
      label: 'Right',
      value: 'flex-end'
    }]
  }]
};
var defaultTitle = {
  '@type': '@builder.io/sdk:Element',
  layerName: 'Accordion item title',
  responsiveStyles: {
    large: {
      marginTop: '10px',
      position: 'relative',
      display: 'flex',
      alignItems: 'stretch',
      flexDirection: 'column',
      paddingBottom: '10px'
    }
  },
  children: [{
    '@type': '@builder.io/sdk:Element',
    responsiveStyles: {
      large: {
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column'
      }
    },
    component: {
      name: 'Text',
      options: {
        text: 'I am an accordion title. Click me!'
      }
    }
  }]
};
var defaultDetail = {
  '@type': '@builder.io/sdk:Element',
  layerName: 'Accordion item detail',
  responsiveStyles: {
    large: {
      position: 'relative',
      display: 'flex',
      alignItems: 'stretch',
      flexDirection: 'column',
      marginTop: '10px',
      paddingBottom: '10px'
    }
  },
  children: [{
    '@type': '@builder.io/sdk:Element',
    responsiveStyles: {
      large: {
        paddingTop: '50px',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '50px'
      }
    },
    component: {
      name: 'Text',
      options: {
        text: 'I am an accordion detail, hello!'
      }
    }
  }]
};
var accordionConfig = {
  name: 'Builder:Accordion',
  canHaveChildren: true,
  image: 'https://cdn.builder.io/api/v1/image/assets%2FagZ9n5CUKRfbL9t6CaJOyVSK4Es2%2Ffab6c1fd3fe542408cbdec078bca7f35',
  defaultStyles: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch'
  },
  inputs: [{
    name: 'items',
    type: 'list',
    broadcast: true,
    subFields: [{
      name: 'title',
      type: 'uiBlocks',
      hideFromUI: true,
      defaultValue: [defaultTitle]
    }, {
      name: 'detail',
      type: 'uiBlocks',
      hideFromUI: true,
      defaultValue: [defaultDetail]
    }],
    defaultValue: [{
      title: [defaultTitle],
      detail: [defaultDetail]
    }, {
      title: [defaultTitle],
      detail: [defaultDetail]
    }],
    showIf: function showIf(options) {
      return !options.get('useChildrenForItems');
    }
  }, {
    name: 'oneAtATime',
    helperText: 'Only allow opening one at a time (collapse all others when new item openned)',
    type: 'boolean',
    defaultValue: false
  }, {
    name: 'grid',
    helperText: 'Display as a grid',
    type: 'boolean',
    defaultValue: false
  }, {
    name: 'gridRowWidth',
    helperText: 'Display as a grid',
    type: 'string',
    showIf: function showIf(options) {
      return options.get('grid');
    },
    defaultValue: '25%'
  }, {
    name: 'useChildrenForItems',
    type: 'boolean',
    helperText: 'Use child elements for each slide, instead of the array. Useful for dynamically repeating items',
    advanced: true,
    defaultValue: false,
    onChange: function onChange(options) {
      if (options.get('useChildrenForItems') === true) {
        options.set('items', []);
      }
    }
  }]
};
var getRandomAspectTile = function getRandomAspectTile() {
  return __assign(__assign({}, defaultTile), {
    component: __assign(__assign({}, defaultTile.component), {
      options: __assign(__assign({}, defaultTile.component.options), {
        // range from 0.5 to 2, rounded to 2 decimal points
        aspectRatio: Math.round((Math.random() * 1.5 + 0.5) * 100) / 100
      })
    })
  });
};
var defaultTile = {
  '@type': '@builder.io/sdk:Element',
  responsiveStyles: {
    large: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      position: 'relative',
      flexShrink: '0',
      boxSizing: 'border-box',
      marginTop: '20px',
      minHeight: '20px',
      minWidth: '20px',
      overflow: 'hidden',
      marginLeft: '20px'
    }
  },
  component: {
    name: 'Image',
    options: {
      image: 'https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d?width=2000&height=1200',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      aspectRatio: 0.7041
    }
  }
};
var masonryConfig = {
  name: 'Builder:Masonry',
  // TODO: default children
  image: 'https://cdn.builder.io/api/v1/image/assets%2FBvYIl5jKN9QpChUB3PVzsTe2ZSI2%2F7ed6bd8129d148608ecec09300786d71?width=2000&height=1200',
  canHaveChildren: true,
  defaultStyles: {
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingBottom: '20px'
  },
  defaultChildren: [getRandomAspectTile(), getRandomAspectTile(), getRandomAspectTile(), getRandomAspectTile(), getRandomAspectTile(), getRandomAspectTile(), getRandomAspectTile(), getRandomAspectTile(), getRandomAspectTile()],
  inputs: [{
    name: 'columnWidth',
    // TODO: type: 'styleNumber'
    type: 'string',
    helperText: 'Width of each tile, as a CSS value. E.g. "200px" or "50%"',
    defaultValue: '200px'
  }, {
    name: 'gutterSize',
    type: 'number',
    helperText: 'Horizontal space between tiles in pixels, e.g. "20" for 20 pixels wide',
    defaultValue: 0,
    advanced: true
  }, {
    name: 'tiles',
    type: 'list',
    subFields: [{
      name: 'content',
      type: 'uiBlocks',
      hideFromUI: true,
      defaultValue: [defaultTile]
    }],
    defaultValue: [],
    showIf: function showIf(options) {
      return !options.get('useChildrenForTiles');
    }
  }, {
    name: 'useChildrenForTiles',
    type: 'boolean',
    helperText: 'Use child elements for each slide, instead of the array. Useful for dynamically repeating tiles',
    advanced: true,
    defaultValue: true,
    onChange: function onChange(options) {
      if (options.get('useChildrenForTiles') === true) {
        options.set('tiles', []);
      }
    }
  }]
};
Builder.registerComponent(CarouselComponent, carouselConfig);
Builder.registerComponent(TabsComponent, tabsConfig);
Builder.registerComponent(AccordionComponent, accordionConfig);
Builder.registerComponent(MasonryComponent, masonryConfig);